import { render, staticRenderFns } from "./ModuleOrderSetupDialog.vue?vue&type=template&id=df53f862&scoped=true&"
import script from "./ModuleOrderSetupDialog.vue?vue&type=script&lang=ts&"
export * from "./ModuleOrderSetupDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleOrderSetupDialog.vue?vue&type=style&index=0&id=df53f862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df53f862",
  null
  
)

export default component.exports